/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Spinoff Platform — Org Contract
 * SpinoffOrgsControllerModule(org/org-labels/org-permissions) 공유 계약. sms-api·commerce-api 등 이 모듈을 마운트하는 호스트 앱이 공통으로 노출하는 엔드포인트만 담는다.
 * OpenAPI spec version: 1.0
 */

export type MemberRole = typeof MemberRole[keyof typeof MemberRole];


export const MemberRole = {
  Owner: 'Owner',
  Admin: 'Admin',
  Member: 'Member',
} as const;
